<template>
    <div class="entity-page-component">
        <div class="tool-bar" >
            <div>
                <v-btn  flat icon light :to="backLink" active-class  ><v-icon>arrow_back</v-icon></v-btn>
                <span class="title">{{ $t("message.Back") }}</span>
            </div>
            <div>
                <v-btn flat icon light v-on:click="save"><v-icon>done</v-icon></v-btn>
            </div>
        </div>
        <div class="entity-page" :style="{ 'min-height': computedPageHeight}">
            <div class="header">
               <v-icon large >business</v-icon>
                <div class="fullname" >{{ entityName }}</div> 
            </div>
            <v-tabs slider-color="secondary" class="app-tabs">
                <v-tab ripple>General</v-tab>
                <v-tab ripple>People</v-tab>
                <v-tab-item>
                     <div class="content">
                        <div class="content-left">
                            <v-text-field v-model="entityName" :label="$t('message.Name')"></v-text-field>
                            <label>{{ $t('message.Description')}}</label>
                            <textarea v-model="entityDescription" ></textarea>
                        </div>
                        <div class="sidebar-right">
                            <v-select :items="workflows" v-model="processId" item-text="name" item-value="processId" :label="$t('message.Workflows')"></v-select>
                            <v-select :items="workflows" v-model="secondaryProcessId" item-text="name" item-value="processId" :label="$t('message.SecondaryWorkflows')"></v-select>
                        </div>
                     </div>
                </v-tab-item>
                <v-tab-item></v-tab-item>
            </v-tabs> 
        </div>
        <v-snackbar
            v-model="showmessage"
            bottom="bottom"
            right="right"
            :timeout="6000"
            >
            <span>{{ alertMessage }}</span>
            <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import ProjectRepository from "../../services/ProjectRepository.js";
import HAL from "../../helpers/HAL.js";

export default {
    name: "ProjectPage",
     computed: {
        computedPageHeight: function() {
            return this.pageHeight + 'px';
        }
    },
    data() {
        return {
            pageHeight: 10,
            entityName: '',
            entityDescription: '',
            projectId: null,
            updateLink: null,
            insertLink: '/api/projects',
            backLink: '/projects',
            showmessage: false,
            alertMessage: '',
            workflows: [],
            processId: null,
            secondaryProcessId: null
        }
    },
     methods: {
        goBack() {
            return '/projects';
        },
        save() {
            var entity = {
                "projectId": this.projectId,
                "description": this.entityDescription,
                "processId": this.processId,
                "secondaryProcessId": this.secondaryProcessId,
                "name": this.entityName
            }
            if(entity.projectId > 0) {
                GenericRepository.update(this.updateLink.href, entity).then(function(response) {
                    if(response.data && response.data.status == 'Success')  {
                        window.vm.$router.push(this.goBack());
                        this.$emit("save");
                    }
                    else {
                        this.alertMessage = response.data.message;
                        this.showmessage = true;
                    }
                 }.bind(this));
            }
            else {
                GenericRepository.insert(this.insertLink, entity).then(function(response) {
                    if(response.data && response.data.status == 'Success')  {
                        window.vm.$router.push(this.goBack());
                        this.$emit("save");
                    }
                    else {
                        this.alertMessage = response.data.message;
                        this.showmessage = true;
                    }
                 }.bind(this));
            }
        }
    },
    created() {
        

        if (!isNaN(this.$route.params.id)) {
            this.pageHeight = window.innerHeight - 57 - 25 - 25;
         GenericRepository.getCollection('api/process')
            .then(response => {
            this.workflows = HAL.getEmbededResources(
                response.data,
                "help:process"
            );
            }).then(() => {
                ProjectRepository.getByID(this.$route.params.id).then(function (response) {
                    if(response.data && response.data.status == 'Success')  {
                        this.entityName = response.data.name;
                        this.entityDescription = response.data.description;
                        this.projectId = response.data.projectId;
                        this.processId = response.data.processId;
                        this.secondaryProcessId = response.data.secondaryProcessId;
                        this.updateLink = HAL.getLink(response.data, 'help:project-update');
                    }
                }.bind(this));
            });
        }
        else {
            GenericRepository.getCollection('api/process')
            .then(response => {
            this.workflows = HAL.getEmbededResources(
                response.data,
                "help:process"
            );
            })
        }
    }
}
</script>

<style lang="stylus">
    @import '../../assets/css/tool-bar.css'
    @import '../../assets/css/entity-page.css'
</style>


